import { Model, ObservableList, ViewModel } from '@neos/core'
import { DataType } from '@neos/shared'
import { CustomViewFilterComponent } from '@src/enums/CustomViewFilterComponent'

/**
 * Represents CustomUIViewDataFilterUI.
 */
export default class CustomUIViewDataFilterUI extends Model {
  /**
   * Initializes a new instance of the CustomUIViewDataFilterUI class.
   * 
   * @param item Item.
   * @param viewModel ViewModel.
   */
  constructor(item?: Record<string, unknown>, viewModel?: ViewModel<CustomUIViewDataFilterUI>) {
    super({
      $new: !item,
      id: 0,
      panelVisible: true,
      position: 0,
      visible: true,
      ...item
    }, viewModel)
  }

  /**
   * Gets or sets Caption.
   */
  caption?: string | null

  /**
   * Gets or sets Component.
   */
  component?: CustomViewFilterComponent | null

  /**
   * Gets or sets Created at.
   */
  createdAt?: Date | null

  /**
   * Gets or sets Created by.
   */
  createdBy?: string | null

  /**
   * Gets or sets Default filter operator.
   */
  defaultOperator?: string | null

  /**
   * Gets or sets Identifier.
   */
  id: number

  /**
   * Gets or sets Property Name.
   */
  name?: string | null

  /**
   * Gets or sets Visible in filter panel.
   */
  panelVisible: boolean

  /**
   * Gets or sets Position.
   */
  position?: number | null

  /**
   * Gets or sets Updated at.
   */
  updatedAt?: Date | null

  /**
   * Gets or sets Updated by.
   */
  updatedBy?: string | null

  /**
   * Gets or sets Visible on screen.
   */
  visible: boolean

  /**
   * Gets or sets Custom view identifier.
   */
  customUIViewId?: string

  /**
   * Gets or sets $keyProperties.
   */
  static $keyProperties = new Set(['id'])

  /**
   * Gets or sets $unboundProperties.
   */
  static $unboundProperties = new Set(['caption'])

  /**
   * Gets or sets $properties.
   */
  static $properties = new Map([['createdAt', { dataType: DataType.dateTime, serverSideReadOnly: true, }], ['createdBy', { dataType: DataType.string, serverSideReadOnly: true, }], ['updatedAt', { dataType: DataType.dateTime, serverSideReadOnly: true, }], ['updatedBy', { dataType: DataType.string, serverSideReadOnly: true, }]])
}